(function () {
    $('.app-switch-button input').on('change', function(e) {
        if (e.target.checked) {
            $('.paid-plan .plan-price').html('$100 <span>/year</span>');
            $('.paid-plan .plan-subtitle').text('paid yearly');
            $('.paid-plan .plan-action').removeClass('premium-btn-monthly').addClass('premium-btn-annually');
        } else{

            $('.paid-plan .plan-price').html('$10 <span>/mo</span>');
            $('.paid-plan .plan-subtitle').text('paid monthly');
            $('.paid-plan .plan-action ').removeClass('premium-btn-annually').addClass('premium-btn-monthly');
        }
    });


})();